"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.IssFailureType = exports.IssResultType = exports.IssEventState = exports.IssPropertyName = void 0;
// Identity standard schema (Iss)
// See also https://msazure.visualstudio.com/One/_git/AD-DataAnalytics-AADDataCommon?path=%2Fsrc%2FIdentityCommonStandardIfx%2FBond%2FIfxISS.bond&version=GBmaster&_a=contents
// See also https://msazure.visualstudio.com/One/_git/AD-DataAnalytics-AADDataCommon?path=%2Fsrc%2FIdentityCommonStandardIfx%2FISS%2FIssEnums.cs&version=GBmaster&_a=contents
// Represents the full IIS Schema
// Event names can be un-commented as needed
var IssPropertyName; // /**
//  * Service/API caller type
//  **/
// export enum IssCallerType {
//   /**
//    * Default value, not specified
//    **/
//   NotSpecified = 0,
//   /**
//    * Web client, browser
//    **/
//   WebClient,
//   /**
//    * Application
//    **/
//   Application,
//   /**
//    * Azure service
//    **/
//   Service,
//   /**
//    * External monitoring service. Note - not used to filter out test traffic.
//    * Use IssBusinessEvent.IsSynthetic to exclude events from the business metrics
//    **/
//   Monitor,
//   /**
//    * External runner service. Note - not used to filter out test traffic.
//    * Use IssBusinessEvent.IsSynthetic to exclude events from the business metrics
//    **/
//   Runner,
//   /**
//    * Other type (not expected to be used)
//    **/
//   Other
// }

/**
 * Indicates the state of the event being logged.
 * For business metrics, the primary QoS metrics,
 * TransactionComplete state is used.
 **/

exports.IssPropertyName = IssPropertyName;

(function (IssPropertyName) {
  IssPropertyName["Action_InternalCorrelationId"] = "Action_InternalCorrelationId";
  IssPropertyName["Action_OperationName"] = "Action_OperationName";
  IssPropertyName["Actor_HashedUserEmail"] = "Actor_HashedUserEmail";
  IssPropertyName["Actor_ObjectId"] = "Actor_ObjectId";
  IssPropertyName["Actor_PUID"] = "Actor_PUID";
  IssPropertyName["Actor_TenantId"] = "Actor_TenantId";
  IssPropertyName["Caller_ClientUserAgent"] = "Caller_ClientUserAgent";
  IssPropertyName["EventState"] = "EventState";
  IssPropertyName["Flighting_FlightName"] = "Flighting_FlightName";
  IssPropertyName["Result_FailureId"] = "Result_FailureId";
  IssPropertyName["Result_FailureSignature"] = "Result_FailureSignature";
  IssPropertyName["Result_FailureType"] = "Result_FailureType";
  IssPropertyName["Result_ResultDescription"] = "Result_ResultDescription";
  IssPropertyName["Result_ResultType"] = "Result_ResultType";
  IssPropertyName["Caller_CorrelationId"] = "Caller_CorrelationId";
  IssPropertyName["Caller_SessionId"] = "Caller_SessionId";
  IssPropertyName["ExtendedProperties_ExtendedProperties"] = "ExtendedProperties_ExtendedProperties";
  IssPropertyName["ExtendedProperties_ExtendedPropertiesType"] = "ExtendedProperties_ExtendedPropertiesType";
  IssPropertyName["IssSchemaVersion"] = "IssSchemaVersion";
  IssPropertyName["SourceNamespace"] = "SourceNamespace";
})(IssPropertyName || (exports.IssPropertyName = IssPropertyName = {}));

var IssEventState;
exports.IssEventState = IssEventState;

(function (IssEventState) {
  IssEventState[IssEventState["NotSpecified"] = 0] = "NotSpecified";
  IssEventState[IssEventState["TransactionStart"] = 1] = "TransactionStart";
  IssEventState[IssEventState["TransactionComplete"] = 2] = "TransactionComplete";
})(IssEventState || (exports.IssEventState = IssEventState = {}));

/**
 * Type of the result of the transaction
 **/
var IssResultType;
/**
 * Type of the failure
 **/

exports.IssResultType = IssResultType;

(function (IssResultType) {
  IssResultType["NotSpecified"] = "NotSpecified";
  IssResultType["Success"] = "Success";
  IssResultType["Failure"] = "Failure";
})(IssResultType || (exports.IssResultType = IssResultType = {}));

var IssFailureType;
exports.IssFailureType = IssFailureType;

(function (IssFailureType) {
  IssFailureType["NotSpecified"] = "NotSpecified";
  IssFailureType["UserError"] = "UserError";
  IssFailureType["ServiceError"] = "ServiceError";
})(IssFailureType || (exports.IssFailureType = IssFailureType = {}));